import { FC } from "react"

import { AccordionSummary, Stack, Typography } from "@mui/material"
import { useQueryClassesById } from "api/reactQuery/queries/classes"
import { useIsBreakpointUp } from "hooks/breakpoint"
import { useUserRole } from "hooks/user"
import { useTranslation } from "react-i18next"

import AutopayBox from "./autopayBox"

type AutopayVariant = "paychecks" | "expenses"

interface IProps {
  title: string
  selectedItemsAmount: number
  autopay?: boolean
  autopayVariant?: AutopayVariant
  classId?: number
}

const Summary: FC<IProps> = ({
  title,
  selectedItemsAmount,
  autopay = false,
  autopayVariant = "paychecks",
  classId,
}) => {
  const { t } = useTranslation()
  const isTablet = useIsBreakpointUp("tablet")

  const userRole = useUserRole()

  const { data: classById } = useQueryClassesById({
    id: Number(classId),
    options: {
      enabled: !!classId && userRole === "teacher",
    },
  })

  const isAutopayActive =
    autopayVariant === "expenses"
      ? classById?.data.expense_automatic
      : classById?.data.paycheck_automatic
  const autopayLabelKey =
    autopayVariant === "expenses"
      ? "transaction.autoexpense"
      : "transaction.autopay"

  return (
    <AccordionSummary>
      <Stack width="100%">
        <Stack
          width="100%"
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={{ mobile: autopay ? "4px" : "0px", tablet: "0px" }}
        >
          <Stack direction="row" gap="10px">
            {title}
            {autopay && isTablet && (
              <AutopayBox
                isActive={isAutopayActive}
                labelKey={autopayLabelKey}
              />
            )}
          </Stack>
          <Typography
            color="mockup.neutral50A"
            variant="body2"
            fontWeight={500}
          >
            {selectedItemsAmount} {t("transaction.selected").toLowerCase()}
          </Typography>
        </Stack>
        {autopay && !isTablet && (
          <AutopayBox isActive={isAutopayActive} labelKey={autopayLabelKey} />
        )}
      </Stack>
    </AccordionSummary>
  )
}

export default Summary
